var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircleLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9314 7.50081C13.9314 3.95545 11.0467 1.07208 7.50219 1.07208C3.95765 1.07208 1.073 3.95545 1.073 7.50081C1.073 11.0451 3.95765 13.9295 7.50219 13.9295C11.0467 13.9295 13.9314 11.0451 13.9314 7.50081ZM15 7.5C15 11.6415 11.6423 15 7.50054 15C3.35769 15 0 11.6415 0 7.5C0 3.35853 3.35769 0 7.50054 0C11.6423 0 15 3.35853 15 7.5ZM7.50151 4.82149C7.94539 4.82149 8.30503 4.4608 8.30503 4.01696C8.30503 3.57311 7.94539 3.2135 7.50151 3.2135C7.05764 3.2135 6.698 3.57311 6.698 4.01696C6.698 4.4608 7.05764 4.82149 7.50151 4.82149ZM8.03687 10.1783H9.10822V11.2496H5.89417V10.1783H6.96552V6.96452H5.89417V5.89325H8.03687V10.1783Z",
    fill: "#066FEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleLightBlue);
export default __webpack_public_path__ + "static/media/info-circle-light-blue.22b738b6366928e01e1b405e2f512bd8.svg";
export { ForwardRef as ReactComponent };